<template>
  <div class="content">
    <div class="form-check-label">
      <div class="offer-container"
        v-if="bannerPlaceHolderWithoutWalletWeb && Object.keys(bannerPlaceHolderWithoutWalletWeb).length">
        <div class="offer-tile">
          Offers
        </div>
        <div class="">
          <!-- <li class="offer-message">
            <img style="width: 20px; padding-bottom: 4px; margin-right: 3px;" data-src="https://tss-static-images.gumlet.io/icons/payment/paypal.png"/>  |  PayPal - Get Flat ₹ 500 off on a minimum purchase of ₹ 999!<br>
            <i class="small"><sup>*</sup>Offer valid only for new Paypal users</i>
          </li> -->
          <!-- <li class="offer-message">
            <img style="width: 24px; padding-bottom: 3px;" data-src="https://tss-static-images.gumlet.io/icons/payment/mobikwik.jpg"/>  |  MobiKwik - Get 15% SuperCash <br />
            Maximum SuperCash that can be availed is ₹200 <br />
            No code required to avail the offer <br />
            Offer valid twice / every (calendar) month between 1st July - 30th September 2020
          </li> -->
          <p v-bind:style="[bannerPlaceHolderWithoutWalletWeb.styles]" class="offer-message" 
            v-if="bannerPlaceHolderWithoutWalletWeb && Object.keys(bannerPlaceHolderWithoutWalletWeb).length">
            {{bannerPlaceHolderWithoutWalletWeb.text}}
          </p>
          <!-- <li class="offer-message">
            <img style="width: 24px; padding-bottom: 3px;" data-src="https://tss-static-images.gumlet.io/icons/payment/amazon-pay.png"/>  |  Amazon Pay Wallet: Get 10% cashback (Maximum ₹ 100) <br />
            Valid once per user. <br />
            Applicable only for transactions done on websites only. <br />
            Offer Valid from 19th Sept till 10th November.
          </li> -->

          <!-- <li class="offer-message">
            <img style="width: 24px; padding-bottom: 3px;" data-src="https://tss-static-images.gumlet.io/icons/payment/ola_money.png"/>  |  Ola Money PostPaid - <br />
            1. Get assured cashback between ₹50-₹500 on a minimum order value of ₹300 <br />
            2. Offer is valid till 31st March 2020 <br />
            3. Valid only for OlaMoney Postpaid active users
          </li> -->
        </div>
      </div>
      <div class="">
        <label
          class="w-100 custom-radio"
          v-if="!eligibility_flag.hasOwnProperty(item.value) || (eligibility_flag.hasOwnProperty(item.value) && eligibility_flag[item.value])"
          v-for="item in this.walletOutageData"
          v-bind:key="item.id"
        >
          <div class="waltcol026 p-2" :style="item.isOutageApplicable && item.isOutageApplicable === 'DOWN' ? `background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };` : ''">
            <div class="wal15">
              <div class="left_img65">
                <div class="image-wrapper" :class="imgHighLight === item.value ? 'image-wrapper-highlight' : ''">
                  <!-- <div class="ribbon" v-if="item.value === 'AMAZONPAY'">
                    <span class="label">Cashback</span>
                  </div> -->
                  <img :style="item.name === 'amazon pay' ?{ marginTop: 10 + 'px' } :''" :data-src="'data:image/png;base64,' + item.image" :alt="item.name"/>
                </div>
                <span class="text-capitalize" style="width:80px; text-align:left">{{ item.name }}</span>
              </div>
              <div class="radio-item" v-if="!(item.isOutageApplicable && item.isOutageApplicable === 'DOWN')">
                <input :id="item.value" name="radio" type="radio" @change="imgHighlightHandler($event)" class="custom-control-input-tapan" :value="item.value" v-model="walletName">
                <label :for="item.value"></label>
              </div>
            </div>
            <wallet-msg
              ref="walletMsg"
              :walletDisName="item.name"
              :isOutageApplicable="item.isOutageApplicable"
            ></wallet-msg>
          </div>
          <div
            v-if="item.isOutageApplicable === 'DOWN' && bannerPlaceHolderFoPayMethodDown"
            :style="`background-color: ${bannerPlaceHolderFoPayMethodDown.banner_color };`"
          >
            <p
              class="offer-message"
              :style="`color: ${bannerPlaceHolderFoPayMethodDown.banner_text_color };`"
            >
              {{bannerPlaceHolderFoPayMethodDown.description}}
            </p>
          </div>
          <div v-if="item.isOutageApplicable === 'FLUCTUATE' && bannerPlaceHolderFoPayMethodFluctuating">
            <p class="offer-message"
              :style="`color: ${bannerPlaceHolderFoPayMethodFluctuating.banner_text_color };`"
            >
              {{bannerPlaceHolderFoPayMethodFluctuating.description}}
            </p>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  // import walletMessage from './walletMessage.vue'
  import walletMsg from './walletMessage.vue'
  export default {
    name: 'walletInput',
    data: function () {
      return {
        wallet: {
          name: '<>'
        },
        walletName: '',
        imgHighLight: null
      }
    },
    props: ['payopt'],
    components: {walletMsg},
    validators: {},
    methods: {
      getWallet: function () {
        let obj = Object.assign({}, this.wallet)
        return obj
      },
      // This is not used at all
      selectWallet: function (wallet) {
        this.walletName = wallet
      },
      // ---->
      imgHighlightHandler (e) {
        this.imgHighLight = e && e.target && e.target.value
      }
    },
    watch: {
      walletName () {
        this.wallet.name = this.walletName
        let nonRadioPayArr = ['cod', 'prepaid', 'cred', 'dcc']
        if (nonRadioPayArr.indexOf(this.payopt) === -1) {
          this.$store.commit('GTAG_EVENT', {eventName: 'PAYMENT_METHOD_SELECT',
            payload: {
              type: this.$parent.getPaymentName(this.$parent.payopt),
              method: (this.walletName.toUpperCase() || 'NA')
            }}
          )
        }
      },
      payopt () {
        if (this.payopt !== 'wallet') {
          this.wallet.name = '<>'
          this.walletName = '<>'
          this.imgHighLight = null
        }
      }
    },
    computed: {
      ...mapGetters(['eligibility_flag', 'bannerPlcaeHolderData', 'wallets', 'payMethodsOutage']),
      // banner when UPI_WEB is added
      bannerPlaceHolderWithoutWalletWeb: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'WALLET_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      bannerPlaceHolderFoPayMethodFluctuating () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_FLUCTUATING'.toLowerCase())
      },
      bannerPlaceHolderFoPayMethodDown () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_DOWN'.toLowerCase())
      },
      walletOutageData () {
        const walletData = this.payMethodsOutage && this.payMethodsOutage.filter(itm => itm.payment_method_type === 'WALLET')
        if (walletData && walletData.length) {
          return this.wallets && this.wallets.map((walletItm) => {
            let specificData = walletData && walletData.filter(subData => (subData.payment_method).toUpperCase() === (walletItm.value).toUpperCase())
            specificData && specificData.length ? walletItm['isOutageApplicable'] = specificData[0].status : ''
            return walletItm
          })
        }
        return this.wallets
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .offer-container {
    cursor: default;
    background: #fff;
    margin: 3.5% 0 1% 0;
    padding: 10px 12px;
    border: 1px solid #eaeaec;
    border-left: 3px solid #117a7a;
    border-radius: 4px;
    font-size: 14px;
    max-width: 100%;
  }
  .offer-tile {
    color: #117a7a;
    font-weight: 100;
    font-size: 1.2em;
    padding-bottom: 2px;
  }
  .offer-message {
    padding: 5px 15px;;
    list-style: none;
    white-space: normal;
  }

  .ribbon {
    position: absolute;
    display: block;
    top: -2px;
    right: 0px;
    width: 70px;
    height: 70px;
    overflow: hidden;
  }

  .ribbon .label {
    position: relative;
    display: block;
    left: 2px;
    top: 10px;
    width: 100px;
    padding: 1px 0px;
    font-size: 0.7em;
    text-align: center;
    color: #fff;
    background-color: #ed2e30;
    opacity: 0.9;
    -webkit-box-shadow: 0px 0px 4px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 4px rgba(0,0,0,0.3);
    -ms-box-shadow: 0px 0px 4px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 4px rgba(0,0,0,0.3);
    -webkit-transform: rotate(45deg) translate3d(0,0,0);
    -moz-transform: rotate(45deg) translate3d(0,0,0);
    -ms-transform: rotate(45deg) translate3d(0,0,0);
    transform: rotate(45deg) translate3d(0,0,0);
  }

  .label:before, .label:after {
    content: '';
    position: absolute;
    bottom: -4px;
    border-top: 4px solid #000;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }

  .label:before {
    left: 0;
  }

  .label:after {
    right: 0;
  }

  .top-right {
    position: absolute;
    top: 8px;
    right: -2px;
    font-size: 0.7em;
    padding: 1px 2px 1px 2px;
    margin-bottom: 10%;
    background-color: #ed2e30;
    color: white;
    margin-left: 5%
  }
  .content {
    margin: 0;
    padding-top: 0px;
  }
  .form-check-label {
    padding: 0 20px;
  }

  img {
    width: 100%;
  }
.wallet {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  
.wallet {
    padding: 0;
    text-align: center;
    margin-bottom:25px;
  }
.custom-control {
    margin-right: 0;
  }
.waltcol026{width:100%}
.wal15{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
.left_img65{display: flex;  align-items: center;}
.left_img65 span{ color:#58595b}  
.image-wrapper {
  border:0;
  border-radius: 50%;
  padding:0px;
  margin: 0;
  width: 40px;
  height:40px;
  margin-right: 18px;
  box-shadow: 0 0 5px #d9caca;
  overflow: hidden;
}

.image-wrapper-highlight {
  border: 3px solid #117a7a !important;
}

 .image-wrapper:hover,
  input[type="radio"]:checked + .image-wrapper {
    border-color: #ed2e30;
  }
 .radio-item {
  display: inline-block;
  position: relative;
  padding: 0 6px;
  margin-top: 4px;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  color: #666;
  font-weight: normal;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 18px;
  height: 18px;
  border-radius: 11px;
  border: 2px solid #ccc;;
  background-color: transparent;
  cursor: pointer;
}
.radio-item input[type=radio]:checked + label:before {
  border: 2px solid #117a7a !important;
}
.radio-item input[type=radio]:checked + label:after {
  border-radius: 11px;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 9px;
  left: 10px;
  content: " ";
  display: block;
  background: #117a7a;
  cursor: pointer;
}
.custom-control-input-tapan{border-color: aqua;width: 18px;height: 18px;}

  @media screen and (max-width: 991px) {
    .form-check-label {
      padding: 0;
    }
  }

  @media (min-width: 991px) {
    .col-lg-2 {
      width: 12%;
    }
    .wallet {
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    .wallet{display: block;}
    .waltcol026{display: flex;}
    .waltcol026{
    display: flex;
    flex-flow: wrap;
    }
    .wal15{width:100%; padding: 0 10px;
    }
  }

  @media screen and (max-width: 576px) {
    
  }


</style>



// WEBPACK FOOTER //
// walletInput.vue?3e87072e